/** Marco da obra combinado com a relação (antes/depois) — contrato do bff (HU 2034). */
export type PapelObraMarco =
  "ANTES_INICIO_OBRA" | "DEPOIS_INICIO_OBRA" | "ANTES_TERMINO_OBRA" | "DEPOIS_TERMINO_OBRA";

/** Entrada: marcada acompanha o início da obra; senão traz `dias` e `marco`. */
export interface PapelObraEntradaRequest {
  inicioDaObra: boolean;
  dias?: number;
  marco?: PapelObraMarco;
}

/** Saída: marcada acompanha o término da obra; senão traz `dias` e `marco`. */
export interface PapelObraSaidaRequest {
  terminoDaObra: boolean;
  dias?: number;
  marco?: PapelObraMarco;
}

export interface PapelObraJanelaRequest {
  entrada: PapelObraEntradaRequest;
  saida: PapelObraSaidaRequest;
}

export interface CreatePapelObraParams {
  nome: string;
  obrigatorio: boolean;
  /** Ausente quando o papel é opcional. */
  janela?: PapelObraJanelaRequest;
  signal?: AbortSignal;
}

export interface UpdatePapelObraParams extends CreatePapelObraParams {
  id: string;
}

export interface InactivatePapelObraParams {
  id: string;
  justificativa: string;
  signal?: AbortSignal;
}

export interface PapelObra {
  id: string;
  nome: string;
  obrigatorio: boolean;
  ativo: boolean;
  /** Papel já aplicado em alguma obra: o nome fica somente leitura na edição. */
  aplicado: boolean;
  janela: PapelObraJanelaRequest | null;
}

export const PAPEIS_OBRA_SORT_FIELDS = ["nome", "ativo"] as const;
export type PapeisObraSortField = (typeof PAPEIS_OBRA_SORT_FIELDS)[number];
export type PapeisObraSortDirection = "asc" | "desc";

export interface PapeisObraSort {
  field: PapeisObraSortField;
  direction: PapeisObraSortDirection;
}

export const DEFAULT_PAPEIS_OBRA_SORT: PapeisObraSort = { field: "nome", direction: "asc" };

export function isPapeisObraSortField(value: unknown): value is PapeisObraSortField {
  return PAPEIS_OBRA_SORT_FIELDS.some((field) => field === value);
}

export interface ListPapeisObraParams {
  busca?: string;
  page?: number;
  pageSize?: number;
  /** Sem ordenação escolhida, o parâmetro não é enviado e vale o padrão do servidor. */
  sort?: PapeisObraSort | null;
  signal?: AbortSignal;
}

export interface PapeisObraPage {
  papeis: PapelObra[];
  total: number;
}

export type PapeisObraStatus = "loading" | "success" | "error" | "forbidden";

export interface PapeisObraQueryState {
  status: PapeisObraStatus;
  papeis: PapelObra[];
  total: number;
  errorMessage: string | null;
}
